import { useMutation } from 'react-query'
import { EmailModel, postEmail } from 'src/shared/services/postEmail'
import Context from 'src/shared/components/ResetPassword/machineConfig/context'
import ResetEvent from 'src/shared/components/ResetPassword/machineConfig/event'
import { SendType } from 'src/shared/types/machine.type'
export default function useSendingEmail(send: SendType<Context, ResetEvent>, isResetPage?: boolean) {
  return useMutation<unknown, unknown, EmailModel, unknown>(postEmail, {
    onSuccess: () => {
      isResetPage ? send({ type: 'RESET_PAGE_SEND' }) : send({ type: 'SEND' })
    },
  })
}
